import React from 'react';
import { PhotoImage } from '../common/PhotoImage';

interface ChatBubbleProps {
  message: string;
  time: string;
  isSent: boolean;              
  showAvatar?: boolean;
  deliveryStatus?: number;      
  userPhotoId?: string | number | null;  
  userName?: string;            
}
 
export default function ChatBubble({
  message,
  time,
  isSent,
  showAvatar = false,
  deliveryStatus,
  userPhotoId,
  userName,
}: ChatBubbleProps) {
  
  const getInitials = (name: string): string => {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };
  return (
    <div className="mb-3">
      <div
        className={`flex items-end gap-2 ${
          isSent ? "justify-end" : "justify-start"
        }`}
      >
        {!isSent && showAvatar && (
          <PhotoImage
            photoId={userPhotoId}
            alt={userName || 'User'}
            className="w-8 h-8 rounded-full object-cover flex-shrink-0 shadow-sm"
            fallback={
              <div className="w-8 h-8 bg-gradient-to-br from-brand-primary to-brand-gray rounded-full flex-shrink-0 shadow-sm flex items-center justify-center text-white text-[11px] font-[600]">
                {userName ? getInitials(userName) : '?'}
              </div>
            }
          />
        )}
 
        <div
          className={`relative px-4 py-2.5 rounded-2xl max-w-[75%] sm:max-w-[70%] shadow-sm ${
            isSent
              ? "bg-gradient-to-br from-brand-primary to-brand-hover text-white rounded-br-md"
              : "bg-white text-[#212121] border border-[#E5E7EB] rounded-bl-md"
          }`}
        >
          <p className="text-[14px] leading-[1.4] m-0 break-words whitespace-pre-wrap">
            {message}
          </p> 
          <div className="flex justify-end items-center gap-1.5 mt-1">
            <span className={`text-[10px] ${isSent ? 'text-white/80' : 'text-[#9E9E9E]'}`}>
              {time}
            </span>
 
            {isSent && typeof deliveryStatus === "number" && (
              <span
                className={`text-[14px] leading-none ${
                  deliveryStatus === 2
                    ? "text-[#4FC3F7]" 
                    : "text-white/70"
                }`}
              >
                {deliveryStatus === 0 && "✓"}
                {deliveryStatus >= 1 && "✓✓"}
              </span>
            )}
          </div>
        </div>
 
        {isSent && <div className="w-8" />}
      </div>
    </div>
  );
}